import React, { Component } from 'react';
import classes from './App.css';
import Header from './layout/Header/Header';
import Square from './components/Square/Square';
import Button from './components/Button/Button';

class App extends Component {

  state = {
    turn: 'X',
    gameEnd: false,
    squares: Array(9).fill(''),
    moves: {
      X:[],
      O:[]
    }
  }

  clicked(event){
    // check to see that the squares is not filled before
    const board = this.state.squares;

    if(board[event.target.dataset.id] === '' && !this.state.gameEnd){
            board[event.target.dataset.id] = this.state.turn;
            event.target.innerHTML = this.state.turn;
            
            this.setState(
            {
              turn: this.state.turn === 'X' ? 'O' : 'X' 
            }
          )
          this.storeMoves(this.state.turn,event.target.dataset.id);
          const hasWon = this.checkWinner(this.state.turn);

          if(this.checkDraw(board) === 'draw' && !hasWon){
            this.setState(
              {
                gameEnd: true,
                matchWonBy: 'nobody'
              }
            )
            console.log('there was a draw')
          }
          ;
    }
    
  }
  storeMoves(turn,move){
      const moves = this.state.moves;
      if(turn === 'X'){
        moves.X.push(move);
      }
      else{
        moves.O.push(move);
      }
  }

  checkWinner(turn){
     /* [
        '0', '1', '2'
        '3', '4', '5'
        '6', '7' ,'8'
        ]
      */
 // wM stands for winning moves.
      const wM = new Set(this.state.moves[turn]);
        if( 
         ( wM.has("0") && wM.has("3") && wM.has("6") ) ||
         ( wM.has("1") && wM.has("4") && wM.has("7") ) ||
         ( wM.has("2") && wM.has("5") && wM.has("8") ) ||
         ( wM.has("0") && wM.has("1") && wM.has("2") ) ||
         ( wM.has("3") && wM.has("4") && wM.has("5") ) ||
         ( wM.has("6") && wM.has("7") && wM.has("8") ) ||
         ( wM.has("0") && wM.has("4") && wM.has("8") ) ||
         ( wM.has("2") && wM.has("4") && wM.has("6") )
          ) 
        {
          this.setState(
            {
            gameEnd:true,
            matchWonBy: turn
            }
          );
          return true;
          
        }
        return false;
  }
  // a draw happens when all the winning squares are filled.

  checkDraw(someArray){
        if(!(someArray.includes(''))){
            return 'draw';
        };
    
  }

restartApp(){
  window.location.reload();
  }

clickEventHandler = () =>{
    this.restartApp();
}



  render() {
    return (
      <div className={classes.app}>

          <Header gameEnd = {this.state.gameEnd} matchWonBy = {this.state.matchWonBy} turn = {this.state.turn}></Header>
          
          <div className = {classes.board__container}> &nbsp;</div>
        
          <div className= {classes.board} onClick = {(e)=> this.clicked(e)}>
              <Square id = '0'></Square>
              <Square id = '1'></Square>
              <Square id = '2'></Square>
              <Square id = '3'></Square>
              <Square id = '4'></Square>
              <Square id = '5'></Square>
              <Square id = '6'></Square>
              <Square id = '7'></Square>
              <Square id = '8'></Square>
          </div>
          <Button click = {this.clickEventHandler} gameEnd = {this.state.gameEnd}/>

      </div>
    
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js